import { GridBaseDataProvider } from '../../../grid/GridBaseDataProvider';
import { Column, ColumnKeys, Dependencies, ScheduleItem, SchedulesMethod, SchedulesResponse } from '../types';
import { API_TYPE_QUARANTINE } from '../../../webcomponents.constants';
import { ConsoleRequest, DataProviderType, FilterKeyMapper } from '../../../utils/request';
import { GetRowsRequest, GetSummaryResponse, UpdateSettingsRequest, UpdateSettingsResponse } from '../../../grid/types/common';
import { TimeRangeKind } from '@nirvana/shared/dtos/types/shared/time';

export class WebAccessControlSchedulerGridDataProvider extends GridBaseDataProvider<Column, ColumnKeys> {
  private endpoint = 'WebAccessControlSchedules';
  private cache: SchedulesResponse | null;
  public companyFilterDataProvider = API_TYPE_QUARANTINE;

  /**
   * Maps column key to different filter key as we filter with a different one.
   */
  private filterKeyMapper: FilterKeyMapper = {
    'company.name': 'company.id',
  };

  constructor(public dependencies: Dependencies) {
    super();
  }

  async getSummary(request: GetRowsRequest<Column, ColumnKeys>): Promise<GetSummaryResponse> {
    const response = await this.readRecords(request);
    return {
      numItems: response.total,
      summary: '',
    };
  }

  async getRows(request: GetRowsRequest<Column, ColumnKeys>): Promise<{ rawEvents: Array<ScheduleItem> }> {
    const response = await this.readRecords(request);
    return { rawEvents: response.data };
  }

  async setFilters(request: any): Promise<{} | undefined> {
    return;
  }

  async updateSettings(request: UpdateSettingsRequest<Column>): Promise<UpdateSettingsResponse> {
    return {};
  }

  private async readRecords(request: GetRowsRequest<Column, ColumnKeys>): Promise<SchedulesResponse> {
    if (this.cache) {
      //tslint:disable-next-line:no-shadowed-variable
      const response = Promise.resolve(this.cache);
      this.cache = null;

      return response;
    }

    const requestFilters: Array<any> = [];
    for (const item of request.filters) {
      if (Object.keys(item)[0] === "updated.date" && item["updated.date"].timeRange.kind === TimeRangeKind.ALL_TO_DATE) {
        continue;
      }
      requestFilters.push(item);
    }

    request.filters = requestFilters;

    const payload = ConsoleRequest.mapGridRequestToPayload(request, Application.Main.getUser().profile.timezone, this.filterKeyMapper);
    payload.filter.push({"property": "company.id", "value": [Application.Main.getActiveCompany().id]});
    const response = await ConsoleRequest.createRequest<SchedulesResponse>({
      dataProviderType: DataProviderType.ENDPOINTS,
      payload,
      endpoint: this.endpoint,
      method: SchedulesMethod.READ_RECORDS,
    });

    this.cache = response;

    return response;
  }
}
